/* #220 (audit accesibilidad, 2026-08-30): el link del carrito en el header
   (sections/header.liquid, markup del tema Xclusive) tiene aria-label="Carrito"
   pero DENTRO muestra el contador de items como texto visible real
   (`<span id="cart-count">`, no oculto: solo el icono que lo envuelve tiene
   aria-hidden, el numero en si sigue siendo texto en pantalla) — Lighthouse
   lo marca como "label-content-name-mismatch" (WCAG 2.5.3): alguien usando
   control por voz que lee "0" en pantalla y dice "toca 0" no encuentra
   coincidencia contra el nombre accesible "Carrito".

   Se corrige aqui, con un observer aislado, en vez de tocar
   custom-async.js (donde `countElement.innerHTML = count` actualiza el
   numero tras cada AJAX add-to-cart) o el snippet del header: así sobrevive
   a que el tema vuelva a escribir el numero, sin heredar el riesgo de parchar
   un archivo del vendor. */
(function () {
  function sincronizar() {
    var contador = document.getElementById('cart-count');
    if (!contador) return;
    var link = contador.closest('a[aria-label]');
    if (!link) return;
    var base = link.getAttribute('data-mi-label-base');
    if (base === null) {
      base = link.getAttribute('aria-label') || '';
      link.setAttribute('data-mi-label-base', base);
    }
    var numero = contador.textContent.trim();
    link.setAttribute('aria-label', base + ' (' + numero + ')');
  }

  function iniciar() {
    var contador = document.getElementById('cart-count');
    if (!contador) return;
    sincronizar();
    new MutationObserver(sincronizar).observe(contador, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
